export default [

  {
    path: '/service',
    name: '场地',
    component: function (resolve) {
      require(['@/pages/userPage/service/list'], resolve)
    }
  },
  {
    path: '/service/view',
    name: '场地',
    component: function (resolve) {
      require(['@/pages/userPage/service/view'], resolve)
    }
  },
  {
    path: '/service/add',
    name: '场地',
    component: function (resolve) {
      require(['@/pages/userPage/service/add'], resolve)
    }
  },


]


// WEBPACK FOOTER //
// ./src/router/userLayout/service.js